<template>
  <div style="width:100vw;height:100vh;background: black" :style="{'--guide-line-left': guideLeft}">

    <Ripple/>
    <!--    <div class="ripple-container">-->
    <!--      <div class="ripple"></div>-->
    <!--      <div class="ripple"></div>-->
    <!--      <div class="ripple"></div>-->
    <!--      <div class="ripple"></div>-->
    <!--      <div class="ripple"></div>-->
    <!--      <div class="ripple"></div>-->
    <!--      <div class="ripple"></div>-->
    <!--    </div>-->
    <!--      <Ripple/>-->
    <div class="text-center text-white mt-20" style="font-size:30px;font-family: 'outfit">
      Enjoy Your OMNI Journey
    </div>
    <div class="third-color text-18px text-center mt-2">Getting ready for OMNI 3.0 upgrade</div>
    <div class="flex flex-row guide-line-layout" v-if="isBrandUser" @click="onFuncTypeSelect">
      <van-image class="mt-2.5" :src="require('@/assets/icons/v2/icon_guide_line.png')" width="64" height="108"/>
      <span class="guide-text">1. Choose Connection Type</span>
    </div>
    <template v-if="isBrandUser">
      <div ref="guideLineNfcLayout" class="flex flex-row guide-line-nfc-layout">

        <van-image class="mt-2.5" :src="require('@/assets/icons/v2/icon_guide_line_nfc_brand.png')" width="54"
            height="56"/>
        <span class="guide-text">2. Read Your Device</span>
      </div>
    </template>
    <template v-else>
      <div ref="guideLineNfcLayout" class="flex flex-col items-center guide-line-nfc-layout" v-if="funcType === 2">
        <span class="guide-text ">Retrieve Your Device</span>
        <van-image class="mt-2" :src="require('@/assets/icons/v2/icon_guide_line_nfc.png')" width="16" height="53"/>
      </div>
    </template>
    <BottomGuideOperate ref="guideOperate" :func-type="funcType" @onRead="onReadClick"
        @onFuncTypeChange="onFuncTypeChange"/>

    <PopupAd v-model="showNewVersion" :advertise="newVersionAd" :enable-count-down="false"/>
  </div>
</template>

<script>
import BottomGuideOperate from "@/components/home/BottomGuideOperate.vue";
import userMixin from "@/mixins/userMixin";
import Ripple from "@/components/home/Ripple";
import PopupAd from "@/components/common/PopupAd.vue";

export default {
  name: "NFCGuideMask",
  components: { PopupAd, Ripple, BottomGuideOperate },
  mixins: [userMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    funcType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      guideLeft: 0,
      showNewVersion: !localStorage.getItem("show_new_version"),
      newVersionAd: {
        eventCoverImage: require("@/assets/icons/ic_new_version.jpg"),
        eventName: "Join us before Dec 24. 2024 to get a LIMITED FREE TRIAL.",
        nickName: "OMNI3.0",
        startTime: "2024-05-09 00:00:00"
      }
    };
  },
  watch: {
    showNewVersion(val) {
      if (!val) {
        localStorage.setItem("show_new_version", true);
      }
    },
    value(newVal) {
      if (!newVal) {
        return;
      }
      this.$nextTick(() => {
        if (this.isBrandUser) {
          const left = this.$refs.guideOperate.$refs.readBtn.offsetLeft;
          const width = this.$refs.guideOperate.$refs.readBtn.clientWidth;
          const guideLineNfcLayoutWidth = this.$refs.guideLineNfcLayout.clientWidth;
          this.guideLeft = `${left + width / 2}px`;
        } else {
          const left = this.$refs.guideOperate.$refs.connectBtn.offsetLeft;
          const width = this.$refs.guideOperate.$refs.connectBtn.clientWidth;
          const guideLineNfcLayoutWidth = this.$refs.guideLineNfcLayout.clientWidth;
          this.guideLeft = `${left + width / 2 - guideLineNfcLayoutWidth / 2}px`;
        }
      });
    }
  },
  methods: {
    onClickHideGuide() {
      if (this.funcType === 1) {
        this.$store.dispatch("bluetooth/setShowBtGuide", true);
        this.$emit("input", false);
      } else {
        this.$store.dispatch("nfc/setShowNfcGuide", true);
        this.$emit("input", false);
      }
    },
    onFuncTypeChange(e) {
      this.$emit("onFuncTypeChange", e);
    },
    onReadClick() {
      this.$emit("onRead");
    },
    onWriteClick() {
      this.$emit("onWrite");
    },
    onFuncTypeSelect() {
      this.$emit("onFuncTypeSelect");
    }
  },
  computed: {},
  mounted() {

    this.$nextTick(() => {

      if (!this.$refs.guideLineNfcLayout) {
        return;
      }
      if (this.isBrandUser) {
        const left = this.$refs.guideOperate.$refs.readBtn.offsetLeft;
        const width = this.$refs.guideOperate.$refs.readBtn.clientWidth;
        const guideLineNfcLayoutWidth = this.$refs.guideLineNfcLayout.clientWidth;
        this.guideLeft = `${left + width / 2}px`;
      } else {
        const left = this.$refs.guideOperate.$refs.connectBtn.offsetLeft;
        const width = this.$refs.guideOperate.$refs.connectBtn.clientWidth;
        const guideLineNfcLayoutWidth = this.$refs.guideLineNfcLayout.clientWidth;
        this.guideLeft = `${left + width / 2 - guideLineNfcLayoutWidth / 2}px`;
      }
    });
  }
};
</script>

<style scoped lang="less">
.van-popup {
  background: black;
}

.guide-line-layout {
  position: fixed;
  left: 40px;
  bottom: calc(60px + env(safe-area-inset-bottom));
}

.guide-line-nfc-layout {
  position: fixed;
  left: var(--guide-line-left);
  bottom: calc(60px + env(safe-area-inset-bottom));
}

.guide-text {
  color: white;
  font-size: 16px;
  margin-top: 4px;
  margin-left: 10px;
}


.ripple-container {
  position: relative;
  width: 390px;
  height: 390px;
  overflow: hidden;
}

.ripple {
  position: absolute;
  border-radius: 50%;
  width: 0px;
  height: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  //background: white;
  border: 10px solid white;
  animation: ripple-animation 8s ease-in-out infinite;
  -webkit-backface-visibility: hidden;
  overflow: hidden;
}

.ripple:nth-child(2) {
  animation-delay: 1s;
}

.ripple:nth-child(3) {
  animation-delay: 2s;
}

.ripple:nth-child(4) {
  animation-delay: 3s;
}

.ripple:nth-child(5) {
  animation-delay: 4s;
}

.ripple:nth-child(6) {
  animation-delay: 5s;
}

.ripple:nth-child(7) {
  animation-delay: 6s;
}

.ripple:nth-child(8) {
  animation-delay: 5s;
}

.ripple:nth-child(9) {
  animation-delay: 7s;
}

@keyframes ripple-animation {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    width: 0px;
    height: 0px;
    border: 8px solid white;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.777);
    opacity: 0;
    width: 390px;
    height: 390px;
    border: 2px solid white;
  }
}

</style>